<template>
    <svg
        id="Layer_1"
        data-name="Layer 1"
        viewBox="0 0 907.27 906.54"
        xmlns="http://www.w3.org/2000/svg">
        <path
            class="cls-4"
            d="M156.88,457.77L.01,455.77c-.58-78.94,19.59-157.29,56.03-226.82l139.79,79.45c-25.63,45.22-39.72,97.09-38.95,149.37Z" />
        <path
            class="cls-18"
            d="M681.39,61l-81.53,135.84c-43.03-23.77-91.83-37.64-141.27-37.9L455.59,0c79.42.27,157.17,21.93,225.8,61Z" />
        <path
            class="cls-11"
            d="M451.6,752.61l1,153.93c-79.97.99-158.72-21.96-227.8-60.99l82.9-130.47c44.03,23.6,93.48,38.25,143.9,37.53Z" />
        <path
            class="cls-3"
            d="M907.18,453.77h-155.86c-1.17-50.78-13.88-100.32-38.86-144.44l136.21-76.44c39.39,66.2,57.8,143.83,58.5,220.88Z" />
        <path
            class="cls-6"
            d="M846.23,227.87l-137.86,75.97c-20.13-36.64-50.75-67.59-84.62-91.77-3.26-2.33-13.56-7.82-15.31-9.68-.56-.6-1.12-1.03-1-1.96l79.41-135.49c65.85,39.26,122.08,95.84,159.38,162.92Z" />
        <path
            class="cls-13"
            d="M905.68,459.77c1.64,1.08,1.6,2.68,1.59,4.49-.29,54.23-15.53,118.44-36.88,168.1-2.52,5.85-22.87,48.82-25.63,49.05l-131.39-80.73c20.72-37.11,33.26-78.92,36.96-121.43.56-6.41-.4-13.05,1.01-19.48h154.36Z" />
        <path
            class="cls-1"
            d="M298.69,202.82c-40.23,24.24-75.64,59.21-98.87,100.03L60.88,223.29c36.83-66.34,94.14-119.3,159.44-157.3l78.37,136.83Z" />
        <path
            class="cls-5"
            d="M197.74,605.75c24.61,44.21,62.23,79.91,104.98,106.38l-81.93,130.43c-65.36-39.18-121.38-94.84-158.89-161.35l135.84-75.47Z" />
        <path
            class="cls-16"
            d="M842.24,686.67c-39.07,65.56-95.13,121.02-161.41,158.91l-73.41-134.52.16-1.28c42.69-25.03,77.53-61.97,103.26-104.03l131.39,80.92Z" />
        <path
            class="cls-7"
            d="M602.45,713.63l72.95,135.91c-66.31,35.71-140.9,57.26-216.81,56.99l-1-153.93c50.85.4,100.65-14.74,144.86-38.97Z" />
        <path
            class="cls-19"
            d="M156.88,463.76c.91,47.74,14.43,94.56,36.89,136.33l-135.2,75.48C20.99,611.11,1.85,536.49.01,461.76l156.87,2Z" />
        <path
            class="cls-9"
            d="M449.61,0l2.99,158.92c-25.62-.22-51.24,3.44-75.93,9.99l17.51-94.96-92.44-47.95C349.15,9.42,399.21.46,449.61,0Z" />
        <path
            class="cls-1"
            d="M320.54,216.64s-.22.02-.22.02c-33.42-56.45-63.99-114.46-95.52-171.98,1.87-1.35,3.07-.21,4.26.37,37.53,18.41,75.05,36.87,112.6,55.24,2.93,1.43,3.45,3.03,2.74,6.23-7.66,34.47-15.12,68.98-22.62,103.49-.48,2.2-.83,4.42-1.25,6.63Z" />
        <path
            class="cls-20"
            d="M267.58,395.98c-.08-37.9-4.26-82.15,26.13-110.4,32.83-30.52,104.5-27.72,131.96,9.22,17.71,23.82,16.9,47.79,17.92,75.87.04,1-.62,3.09.82,2.89l45.26-104.56h62.68v185.07h30.72v70.54h34.87v-70.54h29.89v191.71h-29.89v-68.05h-34.87v68.05h-88.01v-68.05h-114.57v-53.53c0-3.33,17.62-39.9,20.17-47.9.18-.56,1.52-3.02-.24-1.91-6.22,6.77-11.72,14.28-17.84,21.18-15.59,17.6-56.88,57.98-56.88,81.74v15.35h111.67l1.25,1.24v51.87h-171.03c.75-26.45-2.43-52.92,3.73-78.85,17.41-73.29,100.83-107.16,112.29-183.2,2.22-14.71,3.02-42.79-5.75-55.24-11.41-16.21-42.1-13.64-50.89,4.43-.78,1.61-3.75,10-3.75,11.19v50.62l-1.25,1.24h-54.38ZM495.07,523.78v-141.09l-59.78,141.09h59.78Z" />
        <path
            class="cls-22"
            d="M617.9,524.47c-.13-.22-.08-.39.14-.52.7-1.47.35-3.04.36-4.55.03-20.45.1-40.89-.06-61.34-.03-3.5.93-4.55,4.37-4.37,8.13.42,16.29-.33,24.43.4.52,1.06.31,2.2.31,3.31,0,62.31,0,124.63,0,186.94,0,.7,0,1.4-.09,2.1-1.47,1.19-3.03.77-4.6.29.08-1.82.14-3.63.14-5.45,0-57.41,0-114.82,0-172.22,0-1.21.01-2.42,0-3.07.24.66-.02,1.92-.02,3.15.02,57.13.02,114.26,0,171.38,0,2.08.28,4.22-.65,6.21-7.83.73-15.66.55-23.49.1-.64-1.48-.32-3.04-.32-4.56-.02-19.74,0-39.48-.05-59.23,0-1.46.65-3.08-.58-4.4l.17.18c-1.15-1.2-2.61-.59-3.92-.6-9-.06-17.99-.02-26.99-.05-1.36,0-2.77.32-4.09-.36-.63-9.06-.18-18.13-.25-27.19-.06-8.24-.14-16.47.06-24.71,2.97-1.54,6.15-.5,9.21-.6,7.39-.23,14.79-.03,22.19-.12,1.23-.01,2.73.79,3.72-.72Z" />
        <path
            class="cls-22"
            d="M555.73,647.43h-.87c-1.65-.81-1.21-2.35-1.21-3.69-.02-20.14.01-40.28-.05-60.43,0-2.41.34-4.36,3.21-4.13,7.31.58,14.63.22,21.95.22,3.08,0,4,1.08,3.98,4.18-.12,19.86-.13,39.73,0,59.59.02,3.05-.63,4.09-3.85,4.05-7.72-.09-15.45-.48-23.17.21Z" />
        <path
            class="cls-15"
            d="M555.73,647.43c4.99-1.6,10.11-.32,15.16-.69,3.56-.26,8.11,1.47,10.45-.7,2.6-2.41.86-7.15.89-10.86.12-16.8-.03-33.6.12-50.41.03-3.33-.69-4.64-4.3-4.61-7.03.06-14.07.64-21.1-.36-2.04-.29-2.94,1.01-2.91,3.1.06,4.34.01,8.68.01,13.02,0,15.4,0,30.8,0,46.21,0,1.8-.28,3.66.82,5.3-.59.02-1.19.04-1.78.06-.02-21.42.05-42.85-.15-64.27-.04-3.85,1.2-4.67,4.75-4.53,7.18.29,14.38,0,21.57.12,2.52.04,3.37-.78,3.35-3.36-.09-16.1-.09-32.21,0-48.31.01-2.43-.87-3.14-3.16-3.11-7.61.1-15.21-.01-22.82.07-2.27.02-3.66-.39-3.64-3.15.15-22.26.22-44.51.31-66.77.58-.21,1.02-.04,1.32.5,1.01,2.1.74,4.37.74,6.59.03,18.14,0,36.27.02,54.41,0,5.88.24,6,6.06,6.13,6.74.16,13.5-.52,20.22.42.5.21.94.51,1.32.89.08.52.15,1.05.23,1.57.23.2.31.4.25.61-.06.22-.13.32-.2.32,0,17.39-.01,34.79-.02,52.18.22.21.28.41.19.6-.09.18-.18.26-.27.26-.02,21.68-.1,43.35.03,65.03.02,3.09-.67,4.07-3.84,3.95-7.86-.29-15.74-.17-23.61-.21Z" />
        <path
            class="cls-12"
            d="M647.03,646.69c0-64.15,0-128.31,0-192.46.31-.36.63-.37.96-.04.06,2.23.19,4.47.19,6.7.01,60.4,0,120.79,0,181.19,0,1.54-.12,3.07-.18,4.61-.32.32-.64.31-.96,0Z" />
        <path
            class="cls-2"
            d="M647.99,454.19c-.32.01-.64.03-.96.04-8.01-.03-16.03.13-24.03-.17-3.71-.14-4.26,1.42-4.24,4.66.12,20.14.08,40.28.05,60.42,0,1.61.62,3.38-.75,4.8-.03-22.66-.04-45.33-.11-67.99,0-1.82.18-2.75,2.39-2.72,8.7.13,17.41.05,26.12.06.67,0,1.41-.08,1.55.89Z" />
        <path
            class="cls-21"
            d="M582.96,523.11c-.25-.01-.51-.03-.76-.06-1.23-1.36-1.24-3.06-1.24-4.73-.04-20.06-.05-40.12,0-60.18,0-1.11.05-2.23.41-3.3.21-.53.51-.99.91-1.39.98.15.82.95.82,1.59-.04,22.69-.08,45.37-.13,68.06Z" />
        <path
            class="cls-2"
            d="M617.8,578.63c1.78,1.39.98,3.37.99,5.08.07,21,.06,41.99.08,62.99-.24.34-.49.35-.75.03-.05-21.17-.1-42.34-.17-63.51,0-1.53-.1-3.06-.15-4.59Z" />
        <path
            class="cls-8"
            d="M583.25,525.62c-.02-.31-.04-.62-.05-.94,11.57-.07,23.14-.14,34.71-.21-.79,1.73-2.36,1.15-3.64,1.15-10.34.03-20.68,0-31.01,0Z" />
        <path
            class="cls-2"
            d="M583.15,578.66c.03-.29.05-.57.08-.86,10.33,0,20.66-.03,31,0,1.3,0,2.82-.53,3.74,1.01-11.61-.05-23.21-.1-34.82-.14Z" />
        <path
            class="cls-14"
            d="M618.12,646.73c.25,0,.5-.01.75-.03,7.74,0,15.48,0,23.22,0,.27-.38.55-.39.83-.01,1.37,0,2.75,0,4.12,0,.32,0,.64,0,.96,0-.25,1.22-1.23.86-1.97.86-8.64.02-17.29.02-25.93,0-.71,0-1.71.4-1.97-.82Z" />
        <path
            class="cls-17"
            d="M582.27,453.46c0,.24-.01.49-.02.73-9.38,2.19-18.76,2.15-28.14.03-.28-.02-.55-.04-.83-.05-.05-.28-.1-.55-.15-.83,9.72.04,19.43.08,29.15.12Z" />
        <path
            class="cls-10"
            d="M642.91,646.68l-.41.02s-.41,0-.41,0c0-61.96,0-123.92,0-186.23,2.21,1.16,1.63,2.73,1.63,4,.03,59.25.02,118.51.03,177.76,0,1.55.02,3.09-.84,4.46Z" />
        <path
            class="cls-22"
            d="M554.11,454.22c9.38-.01,18.76-.02,28.14-.03-.02,22.96-.03,45.91-.05,68.87-8.16.02-16.32-.07-24.47.11-2.92.06-3.77-.93-3.76-3.85.13-21.7.11-43.4.14-65.1Z" />
    </svg>
</template>

<script setup lang="ts"></script>

<style scoped>
    .cls-1 {
        fill: #ffd405;
    }

    .cls-2 {
        fill: #342253;
    }

    .cls-3 {
        fill: #008cbf;
    }

    .cls-4 {
        fill: #f59e37;
    }

    .cls-5 {
        fill: #d02e2c;
    }

    .cls-6 {
        fill: #3caa36;
    }

    .cls-7 {
        fill: #823683;
    }

    .cls-8 {
        fill: #3c245d;
    }

    .cls-9 {
        fill: #cfd716;
    }

    .cls-10 {
        fill: #46266a;
    }

    .cls-11 {
        fill: #b42d4d;
    }

    .cls-12 {
        fill: #39255f;
    }

    .cls-13 {
        fill: #3d5495;
    }

    .cls-14 {
        fill: #43285b;
    }

    .cls-15 {
        fill: #40285b;
    }

    .cls-16 {
        fill: #522d7c;
    }

    .cls-17 {
        fill: #362254;
    }

    .cls-18 {
        fill: #b6ce3f;
    }

    .cls-19 {
        fill: #e9473b;
    }

    .cls-20 {
        fill: #e33227;
    }

    .cls-21 {
        fill: #3f285a;
    }

    .cls-22 {
        fill: #482667;
    }
</style>
